import Trends from "../../../../components/AssetManagement/Overview/Trends/Trends";

const TrendsScreen = (userToken: any) => {
  const oauthTokenHeader = userToken?.userToken;
  const Websiteresponse = userToken?.response;

  return (
    <>
      <Trends oauthTokenHeader={oauthTokenHeader} response={Websiteresponse} />
    </>
  );
};

export default TrendsScreen;
